var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center pl-3"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.startExam()}}},[(_vm.icon)?_c('span',{staticClass:"exam-icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e(),_c('span',{staticClass:"exam-btn-txt"},[_vm._v(_vm._s(_vm.btnText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }